// /////////////////////////////////////////////////////////////////////////////////////
//                              Copyright (c) 2026
//                                    RXO Inc.
//                          All Rights Reserved Worldwide
//
// WARNING:  This program (or document) is unpublished, proprietary
// property of RXO Inc. and is to be maintained in strict confidence.
// Unauthorized reproduction, distribution or disclosure of this program
// (or document), or any program (or document) derived from it is
// prohibited by State and Federal law, and by local law outside of the U.S.
// /////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import CloseIcon from "../../icons/CloseIcon";
import messages from "../../../helpers/messages";
import SelfPricedEarlyCloseBidActions from "./SelfPricedEarlyCloseBidActions";

function SalesSelfPricedOwnerPendingBidState({ summary, user, hideBanner }) {
  return (
    <>
      <p className="inline-block font-size-14 pt-16 mb-0">
        {messages.bidSuccessfullyUploadedMessage.defaultMessage}
      </p>
      <div className="fr py-8 my-2">
        <SelfPricedEarlyCloseBidActions summary={summary} user={user} />
      </div>
      <CloseIcon
        height="16px"
        width="16px"
        className="fr cursor-pointer mt-16 mr-24"
        onClick={hideBanner}
      />
    </>
  );
}

export default SalesSelfPricedOwnerPendingBidState;
